import { render, staticRenderFns } from "./Gmb.vue?vue&type=template&id=82f570fc&scoped=true&"
import script from "./Gmb.vue?vue&type=script&lang=js&"
export * from "./Gmb.vue?vue&type=script&lang=js&"
import style0 from "./Gmb.vue?vue&type=style&index=0&id=82f570fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f570fc",
  null
  
)

export default component.exports